import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

/**
 * 自选合约的键盘
 */
@Component({
  computed: {
    ...mapState({
      targetSelected: 'targetSelected',
    }),
  },
})
export default class TargetSelectedKeyboard extends Vue {

  @Prop()
  public exclude: Node | Node[] | ((current: Node) => boolean);

  public mounted() {
    //
  }
  public handleClose() {
    this.$emit('close');
  }
  public handleClick(targetId) {
    this.$emit('submit', targetId);
    this.$emit('close');
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/TargetSelectedKeyboard/TargetSelectedKeyboard.ts